import { SectionConfigBuilder } from '../ThemeConfigBuilder';

export default new SectionConfigBuilder()
  .setContext('picker', {
    label: 'Stack',
    description: 'Add a stack',
    icon: 'Stack',
  })
  .setContext('editor', {
    label: 'Stack Section',
    description: '',
    icon: 'Stack',
  })
  .build();
